// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2f2a1e] text-white">
      {/* Scrolling promotions banner */}
      <div className="bg-gradient-to-r from-[#d0b125] to-[#f4d03f] py-3 overflow-hidden relative">
        <div className="animate-marquee whitespace-nowrap flex">
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">✨ Découvrez l'essence du Maroc authentique</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">🌿 Ingrédients naturels soigneusement sélectionnés</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">💫 Senteurs uniques et envoûtantes</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">🌸 Expérience sensorielle 100% marocaine</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">🔥 Beauté, bien-être et authenticité</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">💖 Fabriqué avec passion au Maroc</span>

          {/* Duplicate for seamless loop */}
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">✨ Découvrez l'essence du Maroc authentique</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">🌿 Ingrédients naturels soigneusement sélectionnés</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">💫 Senteurs uniques et envoûtantes</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">🌸 Expérience sensorielle 100% marocaine</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">🔥 Beauté, bien-être et authenticité</span>
          <span className="mx-4 text-[#2f2a1e]">•</span>
          <span className="mx-6 font-semibold text-[#2f2a1e] text-sm">💖 Fabriqué avec passion au Maroc</span>
        </div>

        {/* Gradient overlays for smooth edges */}
        <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-[#d0b125] to-transparent"></div>
        <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-[#f4d03f] to-transparent"></div>
      </div>
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <h2 className="text-2xl font-serif font-normal text-[#d0b125] mb-2">
                D4U NATURALLY
              </h2>
              <div className="w-12 h-1 bg-[#d0b125] mb-4"></div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Experience the power of pure Moroccan nature. Our authentic formulations blend traditional wisdom with modern science for visible, lasting results.
            </p>
            <div className="flex items-center space-x-2 text-sm text-gray-300">
              <span className="w-2 h-2 bg-[#d0b125] rounded-full"></span>
              <span>100% Natural Ingredients</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-300 mt-1">
              <span className="w-2 h-2 bg-[#d0b125] rounded-full"></span>
              <span>Moroccan Heritage</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 relative">
              Quick Links
              <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[#d0b125]"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="text-gray-300 hover:text-[#d0b125] transition-colors duration-200 text-sm flex items-center group">
                  <span className="w-1 h-1 bg-[#d0b125] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Shop All
                </Link>
              </li>
              <li>
                <Link to="/men" className="text-gray-300 hover:text-[#d0b125] transition-colors duration-200 text-sm flex items-center group">
                  <span className="w-1 h-1 bg-[#d0b125] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Men's Collection
                </Link>
              </li>
              <li>
                <Link to="/women" className="text-gray-300 hover:text-[#d0b125] transition-colors duration-200 text-sm flex items-center group">
                  <span className="w-1 h-1 bg-[#d0b125] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Women's Collection
                </Link>
              </li>
              <li>
                <Link to="/our-universe" className="text-gray-300 hover:text-[#d0b125] transition-colors duration-200 text-sm flex items-center group">
                  <span className="w-1 h-1 bg-[#d0b125] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Our Story
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 relative">
              Support
              <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[#d0b125]"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/Help" className="text-gray-300 hover:text-[#d0b125] transition-colors duration-200 text-sm flex items-center group">
                  <span className="w-1 h-1 bg-[#d0b125] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/Help" className="text-gray-300 hover:text-[#d0b125] transition-colors duration-200 text-sm flex items-center group">
                  <span className="w-1 h-1 bg-[#d0b125] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/Help" className="text-gray-300 hover:text-[#d0b125] transition-colors duration-200 text-sm flex items-center group">
                  <span className="w-1 h-1 bg-[#d0b125] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link to="/Help" className="text-gray-300 hover:text-[#d0b125] transition-colors duration-200 text-sm flex items-center group">
                  <span className="w-1 h-1 bg-[#d0b125] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 relative">
              Connect With Us
              <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[#d0b125]"></div>
            </h3>
            <div className="space-y-4">
              <div>
                <p className="text-gray-300 text-sm mb-2">Stay updated with our latest products and offers</p>
                <div className="flex space-x-3">
                  <a
                    href="https://www.instagram.com/d4unaturally"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#d0b125] text-[#2f2a1e] p-2 rounded-lg hover:bg-[#f4d03f] transition-colors duration-200"
                  >
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>
                  <a
                    href="https://www.facebook.com/d4unaturally"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#d0b125] text-[#2f2a1e] p-2 rounded-lg hover:bg-[#f4d03f] transition-colors duration-200"
                  >
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </a>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-700">
                <p className="text-gray-300 text-sm">
                  📧 d4unaturally@gmail.com
                </p>
                <p className="text-gray-300 text-sm mt-1">
                  📞 +41783292404
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-300 text-sm text-center md:text-left mb-4 md:mb-0">
            <p>&copy; 2025 D4U Naturally.</p>
          </div>
          <div className="flex space-x-6 text-sm text-gray-300">
            <Link to="/privacy" className="hover:text-[#d0b125] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#d0b125] transition-colors">Terms of Service</Link>
            <Link to="/cookies" className="hover:text-[#d0b125] transition-colors">Cookies</Link>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
          display: inline-flex;
        }
        
        /* Pause animation on hover */
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </footer>
  );
}